import PropTypes from 'prop-types';
import React from 'react';
import Icon from './Icon';

const ErrorBubble = ({
  show,
  errors,
  InfoMessage,
  onHide,
  warningMessage,
  successMessages,
  forwardedRef,
  hideCloseButton,
}) => {
  return (
    <div className={`ReactBubbleContainer ${show ? 'show' : ''}`} ref={forwardedRef}>
      <div
        className={`
            ErrorBubble
            ${InfoMessage && InfoMessage.length > 0 ? ' info' : ''}
            ${warningMessage && warningMessage.length > 0 ? ' warning' : ''}
            ${successMessages && successMessages.length > 0 ? ' success' : ''}
          `}
      >
        <div className="icon">
          <Icon
            className={`fa ${
              successMessages && successMessages.length > 0 ? 'fa-check' : 'fa-exclamation'
            }`}
          />
        </div>

        {!hideCloseButton && <Icon onClick={onHide} className="fa fa-times close" />}

        {errors && errors.length > 0 && (
          <ul className="messages">
            {errors.map(error => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        )}

        {InfoMessage && InfoMessage.length > 0 && (
          <ul className="messages">
            {InfoMessage.map(message => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        )}

        {successMessages && successMessages.length > 0 && (
          <ul className="messages">
            {successMessages.map(message => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        )}

        {warningMessage && warningMessage.length > 0 && (
          <ul className="messages warning-message-list">
            {warningMessage.map(message => (
              <li key={message} className="warning-message">
                {message}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

ErrorBubble.defaultProps = {
  onHide: () => {},
  show: false,
  errors: [],
  InfoMessage: [],
  warningMessage: [],
  successMessages: [],
  forwardedRef: null,
  hideCloseButton: false,
};

ErrorBubble.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string.isRequired),
  InfoMessage: PropTypes.arrayOf(PropTypes.string),
  onHide: PropTypes.func,
  show: PropTypes.bool,
  warningMessage: PropTypes.arrayOf(PropTypes.string.isRequired),
  successMessages: PropTypes.arrayOf(PropTypes.string.isRequired),
  forwardedRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  hideCloseButton: PropTypes.bool,
};

export default React.forwardRef<any, any>((props, ref) => (
  <ErrorBubble {...props} forwardedRef={ref} />
));
